document.addEventListener('DOMContentLoaded', function () {
  var registerBtn = document.getElementById('register-btn');

  if (registerBtn) {
    registerBtn.addEventListener('click', function (event) {
      var emailField = document.getElementById('customer_email');
      var emailFeedback = document.querySelector('.customer_email_feedback');
      var passwordField = document.getElementById('password');
      var password2Field = document.getElementById('password2');
      var passwordFeedback = document.querySelector('.password_feedback');
      var password2Feedback = document.querySelector('.password2_feedback');
      var clientNumberField = document.getElementById('client-number');
      var clientNumberFeedback = document.querySelector(
        '.client_number_feedback'
      );

      if (emailField && emailFeedback) {
        var email = emailField.value;
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailPattern.test(email)) {
          event.preventDefault();
          emailField.classList.add('is-invalid');
          emailFeedback.style.display = 'block';
          emailFeedback.textContent = 'Voer een geldig e-mailadres in.';
        } else {
          emailField.classList.remove('is-invalid');
          emailFeedback.style.display = 'none';
        }
      }

      if (
        passwordField &&
        password2Field &&
        passwordFeedback &&
        password2Feedback
      ) {
        if (passwordField.value !== password2Field.value) {
          event.preventDefault();
          passwordField.classList.add('is-invalid');
          password2Field.classList.add('is-invalid');
          passwordFeedback.style.display = 'block';
          password2Feedback.style.display = 'block';
          passwordFeedback.textContent = 'Wachtwoorden komen niet overeen.';
          password2Feedback.textContent = 'Wachtwoorden komen niet overeen.';
        } else {
          passwordField.classList.remove('is-invalid');
          password2Field.classList.remove('is-invalid');
          passwordFeedback.style.display = 'none';
          password2Feedback.style.display = 'none';
        }
      }

      if (clientNumberField && clientNumberFeedback) {
        var clientNumber = clientNumberField.value;
        var clientNumberPattern = /^[0-9]+$/;

        if (!clientNumberPattern.test(clientNumber)) {
          event.preventDefault();
          clientNumberField.classList.add('is-invalid');
          clientNumberFeedback.style.display = 'block';
          clientNumberFeedback.textContent =
            'Klantnummer mag alleen cijfers bevatten.';
        } else {
          clientNumberField.classList.remove('is-invalid');
          clientNumberFeedback.style.display = 'none';
        }
      }
    });
  }
});
